<style>
    .table-dashboard thead tr td {
        background: #1f2248;
        color: #fff;
    }
    </style>
    <template>
        <zen-one
            :showuserinfo="false"
            title="Sistem Hasil Bersepadu Kedah (iHasil)"
            :crumbs="crumbs"
        >
            <z-page title=" Laporan Penyata Pemungut">
                <w-form ref="dform" @validate="search">
                    <w-flex class="mt3">
                        <div class="xs6 mr3">
                            <w-input
                                v-model="cari.tarikh_dari"
                                required
                                label="Dari"
                                type="date"
                            />
                            <z-lookup
                                label="Jabatan"
                                :url="service_kutipan + 'lookup/jabatan_user'"
                                :sort="false"
                                :cache="false"
                                v-model="cari.jabatan_id"
                            />
                        </div>
                        <div class="xs6 mr3">
                            <w-input
                                v-model="cari.tarikh_hingga"
                                required
                                label="Hingga"
                                type="date"
                            />
                            <z-lookup
                                label="Jenis Kaunter"
                                :url="service_laporan + 'lookup/lkp_kaunter_baharu'"
                                :sort="false"
                                :cache="false"
                                v-model="cari.lkp_kaunter_id"
                            />
                        </div>
                    </w-flex>
                </w-form>
    
                <w-flex class="mt1 mb3" justify-end>
                    <div class="mt2 text-right">
                        <w-button
                            class="ml1"
                            v-on:click="reset()"
                            bg-color="warning"
                        >
                            <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                        </w-button>
                        <w-button class="ml1" @click="$refs.dform.validate()">
                            <w-icon>fal fa-search</w-icon>&nbsp;Cari
                        </w-button>
                    </div>
                </w-flex>
    
                <w-flex justify-center align-center class="mt5">
                <div class="w-card__content content-hardcode" style="overflow-x:auto;">
                    <loading v-model:active="isLoading"
                    :can-cancel="false"
                    :opacity="0.7"
                    :is-full-page="false"/>
                    <table class="table-dashboard" width="100%" >
                        <thead>
                            <tr>
                                <td rowspan="2">Bil</td>
                                <td colspan="2">P.Penyata Pemungut</td>
                                <td colspan="3">Tempoh Pungutan</td>
                                <td colspan="2">Membayar</td>
                                <td colspan="8" style="text-align:center;">Dimasukira</td>
                                <td rowspan="2">No. Resit BN</td>
                                <td rowspan="2">Tarikh Resit BN</td>
                                <td rowspan="2">Kod Status</td>
                                <td rowspan="2">Amaun<br>(RM)</td>
                            </tr>
                            <tr>
                                <td>No. RUJ</td>
                                <td>Tarikh</td>
                                <td>Dari</td>
                                <td>Hingga</td>
                                <td>Jumlah</td>
                                <td>Jab</td>
                                <td>PTJ/PK</td>
                                <td>VOT</td>
                                <td>JAB</td>
                                <td>PTJ/PK</td>
                                <td>PROG/AKT</td>
                                <td>PROJEK</td>
                                <td>SETIA</td>
                                <td>CP</td>
                                <td>KOD AKAUN</td>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-if="table.items.length > 0">
                                <tr v-for="(dt, index) in table.items">
                                    <template v-if="index == 0 || table.items[index-1] && table.items[index-1].no_penyata_pemungut != dt.no_penyata_pemungut">
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.no }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.no_penyata_pemungut }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.tarikh_sedia }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.tarikh_bayar }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.tarikh_bayar }}</td>
                                        <td style="border-top: 1px solid #000000 !important;text-align:right;">{{ dt.amaun_pemungut }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.kod_jabatan }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.kod_ptj }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.kod_vot }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.kod_jabatan }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.kod_ptj }}</td>
                                        <td style="border-top: 1px solid #000000 !important;"></td>
                                        <td style="border-top: 1px solid #000000 !important;"></td>
                                        <td style="border-top: 1px solid #000000 !important;"></td>
                                        <td style="border-top: 1px solid #000000 !important;"></td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.kod_akaun }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.no_resit_perbendaharaan }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.tarikh_resit_perbendaharaan }}</td>
                                        <td style="border-top: 1px solid #000000 !important;">{{ dt.status }}</td>
                                        <td style="border-top: 1px solid #000000 !important;text-align:right;">{{ dt.amaun_butiran }}</td>
                                    </template>
                                    <template v-else>
                                        <td>{{ dt.no }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td style="text-align:right;"></td>
                                        <td></td>
                                        <td></td>
                                        <td>{{ dt.kod_vot }}</td>
                                        <td>{{ dt.kod_jabatan }}</td>
                                        <td>{{ dt.kod_ptj }}</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td>{{ dt.kod_akaun }}</td>
                                        <td>{{ dt.no_resit_perbendaharaan }}</td>
                                        <td>{{ dt.tarikh_resit_perbendaharaan }}</td>
                                        <td>{{ dt.status }}</td>
                                        <td style="text-align:right;">{{ dt.amaun_butiran }}</td>
                                    </template>
                                </tr>
                            </template>
                            <template v-else>
                                <tr>
                                    <td colspan="20" style="text-align: center">Tiada Rekod</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    <w-card class="text-right">
                        <w-flex
                            v-if="table.meta && table.meta.current_page"
                            class="justify-start align-center"
                        >
                            <pagination
                                class="xs11"
                                :max="table.meta.last_page"
                                :path="table.meta.path"
                                :current="table.meta.current_page"
                                :last_page="table.meta.last_page"
                                :links="table.meta.links"
                                @pageChanged="table.loadpg"
                            />
                        </w-flex>
                    </w-card>
                </div>
            </w-flex>
    
                <w-flex class="mt1 mb3" justify-center>
                    <div class="mt2 text-center">
                        <w-button bg-color="success" class="mr3" @click="cetak()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                        </w-button>
                    </div>
                </w-flex>
            </z-page>
        </zen-one>
    </template>
    
    <script>
    import { reactive } from "vue";
    import ZenOne from "@/Shared/ZenOne";
    import ZResource from "@/Modules/z-resource-service";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/css/index.css';
    
    export default {
        extends: ZResource,
        components: {
            // ZenOne
            Loading
        },
        props: {
            items: [Array, Object],
            auth: [Array, Object],
        },
        data() {
            return {
                resourceurl: this.service_laporan + "kutipan/laporan/dummy",
                reload: true,
                status: [
                    {
                        value: 1,
                        label: "Aktif",
                    },
                    {
                        value: 2,
                        label: "Tidak Aktif",
                    },
                ],
                crumbs: [
                    { label: "iHasil", route: "/" },
                    { label: "Kutipan", route: "/kutipan/laporan/laporan_penyata_pemungut_3"},
                    { label: "Laporan", route: "/kutipan/laporan/laporan_penyata_pemungut_3"},
                    {
                        label: "Laporan Penyata Pemungut",
                        route: "/kutipan/laporan/laporan_penyata_pemungut_3",
                    },
                ],
                cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", lkp_kaunter_id: "" },
                isLoading: false,
            };
        },
        methods: {
            search() {
                this.getQueryData();
                // this.$inertia.visit(
                //     window.route("kutipan.laporan.laporan_penyata_pemungut_3") + 
                //         "?tarikh_dari=" + this.cari.tarikh_dari +
                //         "&tarikh_hingga=" + this.cari.tarikh_hingga +
                //         "&jabatan_id=" + this.cari.jabatan_id+
                //         "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id,
                //     { preserveScroll: true }
                // );
            },
    
            reset() {
                this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", lkp_kaunter_id: "" };
                this.search();
            },
    
            cetak() {
                window.open(this.service_laporan+'kutipan/laporan/laporan_penyata_pemungut_3/cetak?user_id='+this.auth.user.id+
                "&tarikh_dari=" + this.cari.tarikh_dari +
                "&tarikh_hingga=" + this.cari.tarikh_hingga + 
                "&jabatan_id=" + this.cari.jabatan_id+ 
                "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id,'_blank');
                },
            async getQueryData() {
                this.isLoading = true;
                const resp = await axios.get(
                    this.service_laporan + "kutipan/laporan/laporan_penyata_pemungut_3?user_id=" + this.auth.user.id +
                        "&tarikh_dari=" + this.cari.tarikh_dari +
                        "&tarikh_hingga=" + this.cari.tarikh_hingga +
                        "&jabatan_id=" + this.cari.jabatan_id +
                        "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id +
                        "&page=" + this.cari.page +
                        "&per_page=" + this.cari.per_page,
                );
                this.table = resp.data.data;
                this.table.meta = resp.data.meta;
                this.isLoading = false;
            },
            },
            watch: {},
        mounted() {
            // console.log(this.datas);
            this.dialog.width = 900;
            this.cari = location.search
                .slice(1)
                .split("&")
                .map((p) => p.split("="))
                .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
            if (this.cari.tarikh_dari == "undefined") {
                this.cari.tarikh_dari = "";
            }
            if (this.cari.tarikh_hingga == "undefined") {
                this.cari.tarikh_hingga = "";
            }
            if (this.cari.jabatan_id == "undefined") {
                this.cari.jabatan_id = "";
            }
            if (this.cari.lkp_kaunter_id == "undefined") {
                this.cari.lkp_kaunter_id = "";
            }
            if(typeof this.cari.per_page === 'undefined'){
                this.cari.per_page = 10;
            } else {
                this.cari.per_page = parseInt(this.cari.per_page);
            }
            if(this.cari.page)
                this.getQueryData()
            // console.log(this.auth.user.id);
        },
    };
    </script>
    <style>
    .w-select__menu {
        z-index: 999999;
    }
    </style>
    